export enum TaxSituation {
  DetachedFromParents = 'DetachedFromParents',
  FamilyBreakdown = 'FamilyBreakdown',
  NoSupportFromParents = 'NoSupportFromParents',
  ParentsWithLimitedQuotient = 'ParentsWithLimitedQuotient',
  NoSupportFromPartner = 'NoSupportFromPartner',
}
